
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm1 15.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1zm2.88-7.94a2.89 2.89 0 01-2 2.73l-.88.31a.13.13 0 00-.08.12v.78a.5.5 0 01-.5.5h-.76a.5.5 0 01-.5-.5v-.78a1.88 1.88 0 011.29-1.78l.95-.31a1.13 1.13 0 00.76-1.07V9A1.12 1.12 0 0013 7.88h-2A1.12 1.12 0 009.88 9v.5a.5.5 0 01-.5.5h-.76a.5.5 0 01-.5-.5V9A2.88 2.88 0 0111 6.12h2A2.88 2.88 0 0115.88 9v.56z"}})])
          )
        }
      }
    